import { GetterTree } from "vuex";
import { ScoreState } from "../types";
import { IRootState, IRootGetters } from "../../types";
import { GetterNames } from "./names";
import { getDailyUnitScore, getAuditCScore } from "@dcc/score/auditc";
import { IScoreGetters } from "./types";

export const getters: GetterTree<ScoreState, IRootState> = {
  [GetterNames.DAILYUNITSCORE](
    state: ScoreState,
    getters: IScoreGetters,
    rootState: IRootState,
    rootGetters: IRootGetters
  ): number {
    const dailyUnitsAndCalories = getters[GetterNames.DAILYUNITSANDCALORIES];
    return getDailyUnitScore(dailyUnitsAndCalories.units);
  },

  [GetterNames.AUDITCSCORE](
    state: ScoreState,
    getters: IScoreGetters,
    rootState: IRootState,
    rootGetters: IRootGetters
  ): number {
    const dailyUnitScore = getters[GetterNames.DAILYUNITSCORE];
    const bingeFrequency = rootGetters["drinking/bingeFrequency"];
    const drinkFrequency = rootGetters["drinking/drinkFrequency"];

    return bingeFrequency && drinkFrequency
      ? getAuditCScore({ drinkFrequency, bingeFrequency, dailyUnitScore })
      : 0;
  }
};
